
import getCookie from './get-cookie-by-name';
 const getCurrentLang = () => {
    const currentLang = getCookie('wp-wpml_current_language');
    return currentLang;
}

export default getCurrentLang;